import * as React from "react";
import styled from "react-emotion";
import ScaleLoader from "react-spinners/dist/spinners/ScaleLoader";
import Button from "./Button";

interface ILoaderButtonProps {
  bg?: string;
  children: string;
  disabled?: boolean;
  disableColor?: string;
  loading: boolean;
  size?: string;
  [key: string]: any;
}
const LoaderBox = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
`;
LoaderBox.displayName = "LoaderBox";

const LoaderButton = (props: ILoaderButtonProps) => {
  const { bg, children, disabled, loading, size, disableColor } = props;

  return (
    <Button bg={bg} disabled={disabled} disableColor={disableColor} {...props} size={size}>
      {!loading && children}
      <LoaderBox>
        <ScaleLoader color={"white"} height={0.75} heightUnit="em" loading={loading} width={0.5} widthUnit="em" />
      </LoaderBox>
    </Button>
  );
};

export default LoaderButton;



// WEBPACK FOOTER //
// ./src/components/LoaderButton.tsx